export default [
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('@/views/admin/UsersList.vue'),
    meta: {
      resource: 'users',
      action: 'view',
    },
  },
  {
    path: '/admin/roles',
    name: 'admin-roles',
    component: () => import('@/views/admin/RolesList.vue'),
    meta: {
      resource: 'users',
      action: 'view',
    },
  },
]
